$(document).ready(function () {
  function waitForPrintConfirmation(deviceId, button, buttonText) {
    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        window.globalSocket.removeEventListener(
          'message',
          onConfirmationHandler
        );
        button.prop('disabled', false);
        button.html(buttonText);
        const errorMessage = $('#web-print-error-container').data(
          'print-failed'
        );
        const alertHtml = getAlertHtml(errorMessage, 'danger');
        $('#web-print-error-container').html(alertHtml);
        resolve(false);
      }, 10000);

      const onConfirmationHandler = function (event) {
        try {
          const response = JSON.parse(event.data);

          if (
            response.type === 'web_print_completed' &&
            response.deviceId === deviceId
          ) {
            clearTimeout(timeout);
            window.globalSocket.removeEventListener(
              'message',
              onConfirmationHandler
            );

            if (response.orderIds.length == 0) {
              const errorMessage = $('#web-print-error-container').data(
                'print-failed'
              );
              const alertHtml = getAlertHtml(errorMessage, 'danger');
              $('#web-print-error-container').html(alertHtml);
            }

            button.prop('disabled', false);
            button.html(buttonText);
            resolve(true);
          }
        } catch (e) {
          button.prop('disabled', false);
          button.html(buttonText);

          const errorMessage = $('#web-print-error-container').data(
            'print-failed'
          );
          const alertHtml = getAlertHtml(errorMessage, 'danger');
          $('#web-print-error-container').html(alertHtml);
        }
      };

      document.globalSocket.addEventListener('message', (event) => {
        onConfirmationHandler(event);
      });
    });
  }

  $(document).on('click', '.print-order-from-web', function (event) {
    event.preventDefault();
    const button = $(this);
    const buttonText = button.html();

    const locationId = button.data('location-id');
    const orderData = button.data('order-data');
    const mainPosDeviceId = button.data('main-pos-id');
    const deviceId = localStorage.getItem('deviceID') || 'unknown_device';
    const receiptType = button.attr('data-receipt-type') || '';
    const printerType = button.attr('data-printer-type') || null;
    const printerIpAddress = button.attr('data-printer-ip') || null;

    if (printerType === 'VERIFONE') {
      const printDocumentData = button.data('print-document');
      let printDocument = '';

      if (Array.isArray(printDocumentData)) {
        printDocumentData.map((printData) => {
          printDocument += printData;
        });
      } else {
        printDocument = printDocumentData;
      }

      const verifoneSerialNumber = button.data('printer-ip');
      if (
        window.globalSocket &&
        window.globalSocket.readyState === WebSocket.OPEN
      ) {
        window.globalSocket.send(
          JSON.stringify({
            type: 'verifone',
            action: 'print',
            verifoneSerialNumber: verifoneSerialNumber,
            senderDeviceId: localStorage.getItem('deviceID'),
            printDocument: printDocument,
          })
        );
      }
      return;
    }

    $('#web-print-error-container').html('');

    if (window.ReactNativeWebView) {
      if (receiptType == 'advance_receipt') {
        if (mainPosDeviceId && mainPosDeviceId !== deviceId) {
          checkDeviceActive(mainPosDeviceId).then(function (isActive) {
            if (isActive) {
              let socketData = {
                type: 'main-device-print-service',
                main_pos_device_id: mainPosDeviceId,
                requested_device_id: deviceId,
                printData: {
                  action: 'advance_receipt',
                  data: orderData.orderProducts,
                  ip: printerIpAddress || orderData.ipAddress,
                  type: printerType || orderData.printerType,
                  organizer: orderData.organizer,
                  order: null,
                  deviceId: deviceId,
                  tableNumber: orderData.tableNumber,
                  personName: orderData.tableCustomerName,
                },
              };

              window.globalSocket.send(JSON.stringify(socketData));
            } else {
              showToast({
                type: 'error',
                message:
                  'Hoved POS-enheten må være aktiv for å kunne skrive ut.',
              });
            }
          });
        } else {
          passDataToWebView(
            event,
            'advance_receipt',
            orderData.orderProducts,
            printerIpAddress || orderData.ipAddress,
            printerType || orderData.printerType,
            orderData.organizer,
            null,
            deviceId,
            orderData.tableNumber,
            orderData.tableCustomerName
          );
        }
      } else if (receiptType == 'supply_list') {
        if (mainPosDeviceId && mainPosDeviceId !== deviceId) {
          checkDeviceActive(mainPosDeviceId).then(function (isActive) {
            if (isActive) {
              let socketData = {
                type: 'main-device-print-service',
                main_pos_device_id: mainPosDeviceId,
                requested_device_id: deviceId,
                printData: {
                  action: 'supply_list',
                  data: orderData.orderProducts,
                  ip: orderData.ipAddress,
                  type: orderData.printerType,
                  organizer: orderData.organizer,
                  order: null,
                  deviceId: deviceId,
                  tableNumber: '',
                  personName: '',
                },
              };

              window.globalSocket.send(JSON.stringify(socketData));
            } else {
              showToast({
                type: 'error',
                message:
                  'Hoved POS-enheten må være aktiv for å kunne skrive ut.',
              });
            }
          });
        } else {
          passDataToWebView(
            event,
            'supply_list',
            orderData.orderProducts,
            orderData.ipAddress,
            orderData.printerType,
            orderData.organizer,
            null,
            deviceId,
            '',
            ''
          );
        }
      } else {
        if (mainPosDeviceId && mainPosDeviceId !== deviceId) {
          checkDeviceActive(mainPosDeviceId).then(function (isActive) {
            if (isActive) {
              unshorten(orderData, function (data) {
                let socketData = {
                  type: 'main-device-print-service',
                  main_pos_device_id: mainPosDeviceId,
                  requested_device_id: deviceId,
                  printData: {
                    action: 'web_print_order',
                    data: data,
                    ip: null,
                    type: null,
                    organizer: null,
                    order: null,
                    deviceId: deviceId,
                    tableNumber: '',
                    personName: '',
                  },
                };
                window.globalSocket.send(JSON.stringify(socketData));
              });
            } else {
              showToast({
                type: 'error',
                message:
                  'Hoved POS-enheten må være aktiv for å kunne skrive ut.',
              });
            }
          });
        } else {
          unshorten(orderData, function (data) {
            passDataToWebView(
              event,
              'web_print_order',
              data,
              null,
              null,
              null,
              null,
              deviceId,
              '',
              ''
            );
          });
        }
      }
    } else {
      button.prop('disabled', true);
      button.html('<div class="loader"></div>');
      checkDeviceActive(mainPosDeviceId)
        .then(function (isActive) {
          if (isActive) {
            let socketData = {};
            if (receiptType == 'advance_receipt') {
              socketData = {
                type: 'advance_receipt',
                orderProducts: orderData.orderProducts,
                ipAddress: printerIpAddress || orderData.ipAddress,
                printerType: printerType || orderData.printerType,
                organizer: orderData.organizer,
                main_pos_device_id: mainPosDeviceId,
                requested_device_id: deviceId,
                tableNumber: orderData.tableNumber,
                tableCustomerName: orderData.tableCustomerName,
                date: '',
              };
            } else if (receiptType == 'supply_list') {
              socketData = {
                type: 'supply_list',
                orderProducts: orderData.orderProducts,
                ipAddress: printerIpAddress || orderData.ipAddress,
                printerType: printerType || orderData.printerType,
                organizer: orderData.organizer,
                main_pos_device_id: mainPosDeviceId,
                requested_device_id: deviceId,
                tableNumber: '',
                tableCustomerName: '',
                date: orderData.date,
              };
            } else {
              unshorten(orderData, function (data) {
                socketData = {
                  type: 'web_print_order',
                  location_id: locationId,
                  main_pos_device_id: mainPosDeviceId,
                  order_data: data,
                  requested_device_id: deviceId,
                };
                window.globalSocket.send(JSON.stringify(socketData));
                waitForPrintConfirmation(deviceId, button, buttonText);
              });
              return;
            }

            window.globalSocket.send(JSON.stringify(socketData));

            waitForPrintConfirmation(deviceId, button, buttonText);
          } else {
            button.prop('disabled', false);
            button.html(buttonText);
            const errorMessage = $('#web-print-error-container').data(
              'main-pos-unavailable'
            );
            const alertHtml = getAlertHtml(errorMessage, 'danger');
            $('#web-print-error-container').html(alertHtml);
          }
        })
        .catch(function (error) {
          button.prop('disabled', false);
          button.html(buttonText);
          const errorMessage = $('#web-print-error-container').data(
            'main-pos-unavailable'
          );
          const alertHtml = getAlertHtml(errorMessage, 'danger');
          $('#web-print-error-container').html(alertHtml);
        });
    }
  });
});

function generateUniqueId() {
  return Math.random().toString(36).substr(2, 9);
}

function checkDeviceActive(mainPosDeviceId) {
  return new Promise((resolve, reject) => {
    const pingId = generateUniqueId();
    const pingData = {
      type: 'ping_device',
      target_device_id: mainPosDeviceId,
      sender_id: pingId,
    };
    window.globalSocket.send(JSON.stringify(pingData));

    let timeout = setTimeout(() => {
      window.globalSocket.removeEventListener('message', onPongHandler);
      resolve(false);
    }, 5000);

    const onPongHandler = function (event) {
      try {
        const response = JSON.parse(event.data);
        if (
          response.type === 'pong' &&
          response.from_device_id === mainPosDeviceId &&
          response.original_sender === pingId
        ) {
          clearTimeout(timeout);
          window.globalSocket.removeEventListener('message', onPongHandler);
          resolve(true);
        }
      } catch (e) {
        console.error('❌ Error parsing pong:', e);
      }
    };
    window.globalSocket.addEventListener('message', onPongHandler);
  });
}
